import { NoSearchResult, Paragraph, View } from "@ninjacart/nc-nk-ui";
import { useTranslation } from 'react-i18next';

export function ProductEmptyStateComponent(){
    const { t } = useTranslation();
    return(
        <View
        backgroundColor={'$background'}
        justifyContent="center"
        alignItems="center"
        padding={16}
        marginVertical={20}
        borderRadius={50}
        marginTop={300}
      >
        <NoSearchResult height={100} width={'100%'} />
        <Paragraph
          fontSize={22}
          fontWeight={'600'}
          color={'$color'}
          marginTop={20}
          marginBottom={10}
          padding={8}
        >
          {t('page.sorry')}
        </Paragraph>
        <Paragraph
          fontSize={16}
          fontWeight={'400'}
          color={'$color'}
          paddingBottom={20}
          textAlign="center"
        >
          {t('page.weCouldnotFindMatchesForYourRequirement')}
        </Paragraph>
      </View>
    )
}